import React from "react";
import { array, string } from "prop-types";

import NewsWithImage from "../../../molecules/NewsWithImage";
import DfpAd from "../../../dfp-ad";

import "./organism1.m.css";

const Organism1 = ({ stories, collectionSlug, adSlotId = "default_ad_slot2" }) => {
  return (
    <div styleName="four-col-story">
      {stories.slice(0, 4).map((story, index) => (
        <NewsWithImage key={index} story={story} aspectRatio={[16, 9]} imageType="image16x9" />
      ))}

      <div styleName="horizontal-ad">
        <DfpAd
          adtype="News_728x90_T1"
          collectionSlug={collectionSlug}
          layoutName="BigPhotoStoryCardSlider1Ad"
          slotId={adSlotId}
        />
      </div>
    </div>
  );
};

Organism1.propTypes = {
  stories: array,
  collectionSlug: string,
  adSlotId: string,
};

export default Organism1;
